import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

/**
 * Creates the store — mirrors appointment_booking/CreateStore.js
 *
 * Modernized:
 *   - `configureStore` from RTK replaces `createStore` + manual `compose`
 *   - Redux DevTools enabled automatically (replaces Reactotron enhancer)
 *   - Immer built-in (replaces seamless-immutable)
 */
export default (rootReducer, rootSaga) => {
  /* ------------- Redux Configuration ------------- */
  const middleware = [];

  /* ------------- Saga Middleware ------------- */
  const sagaMiddleware = createSagaMiddleware();
  middleware.push(sagaMiddleware);

  /* ------------- Assemble Middleware ------------- */
  const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        thunk: false,
        serializableCheck: false,
      }).concat(...middleware),
    devTools: process.env.NODE_ENV !== "production",
  });

  // kick off root saga
  const sagasManager = sagaMiddleware.run(rootSaga);

  return {
    store,
    sagasManager,
    sagaMiddleware,
  };
};
